import { toast, ToastContainer } from "react-toastify";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import "react-toastify/dist/ReactToastify.css";
import { useCreateGameMutation } from "../../store/services/gameServices";
import DashboardHeader from "../DashboardHeader";
import { DateRangePicker } from "react-date-range";
import { enUS } from "react-date-range/dist/locale";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { useNavigate } from "react-router";
import { useEffect, useRef, useState } from "react";
import Select from 'react-select';
import { useLazyGetNACCodesQuery } from "../../store/services/nacServices";
import { cities } from "../notifications/AddNotification";
import { LuCheck } from "react-icons/lu";
import CreateGame from "./CreateGame";
import { serializeGameReceiptTypes } from '../../utils/receiptFields';

const validationSchema = Yup.object({
  title: Yup.string().required("Titulli është i detyrueshëm!"),
  description: Yup.string().required("Përshkrimi është i detyrueshëm!"),
  phases: Yup.array().of(
    Yup.object().shape({
      required_receipts: Yup.number()
        .min(1, "Kuponat e kërkuar duhet të jenë më të mëdhenj se zero!")
        .required("Kuponat e kërkuar janë të detyrueshëm!"),
      winning_amount: Yup.number()
        .min(1, "Shuma fituese duhet të jetë më e madhe se zero!")
        .required("Shuma fituese është e detyrueshme!"),
    })
  ),
});

export default function CreateLottery() {
  const [createGame] = useCreateGameMutation();
  const navigate = useNavigate()
  const [searchTextInput, setSearchTextInput] = useState('')
  const [nacCode, setNacCode] = useState(null)
  const [nacOptions, setNacOptions] = useState([])
  const debounceTimeoutRef = useRef(null);
  const [regions, setRegions] = useState(null)

  const [getNacCodes, { data: nacData }] = useLazyGetNACCodesQuery()

  const handleFormSubmit = async (values, { setSubmitting }) => {
    try {
      const start_date = values.dateRange[0].startDate
        ? new Date(values.dateRange[0].startDate).toLocaleDateString('en-CA', { timeZone: "Europe/Amsterdam" })
        : null;

      const end_date = values.dateRange[0].endDate
        ? new Date(values.dateRange[0].endDate).toLocaleDateString('en-CA', { timeZone: "Europe/Amsterdam" })
        : null;

      if (!values.isYearly && (!start_date || !end_date)) {
        toast.error("Zgjidhni një periudhë të vlefshme për lojën!");
        setSubmitting(false);
        return;
      }

      const gameData = new FormData();
      gameData.append('title', values.title);
      gameData.append('description', values.description);
      gameData.append('municipalities_no', (values.municipalities_no && values.municipalities_no.length >= 1) ? values.municipalities_no.map(region => region.value).join(',') : '');
      gameData.append('activities', (values.NAC_codes && values.NAC_codes.length >= 1) ? values.NAC_codes.map(code => code.value).join(',') : '');
      gameData.append('start_date', start_date || '');
      gameData.append('type', 'lottery');
      gameData.append('receipt_type', serializeGameReceiptTypes(values.receipt_type));
      gameData.append('end_date', end_date || '');
      const cleanPhases = values.phases.map(phase => {
        const cleaned = {};
        for (const key in phase) {
          cleaned[key] =
            phase[key] === '' || phase[key] === undefined ? null : phase[key];
        }
        return cleaned;
      });
      gameData.append('tiers', JSON.stringify(cleanPhases));
      if (values.has_business_draw) {
        gameData.append('business_prize_desc', values.business_prize_desc);
        // Max business winners across all tiers of the game; empty = no limit
        if (values.business_winners_limit !== '' && values.business_winners_limit != null) {
          gameData.append('business_winners_limit', values.business_winners_limit);
        }
        gameData.append('fiscal_parity', values.fiscal_parity);
      }
      gameData.append('isYearly', values.isYearly || false);
      gameData.append('protocol_number', values.protocol_number || '');

      if (values.file) {
        gameData.append('file', values.file);
      }

      await createGame(gameData).unwrap();
      toast.success("Loja u krijua me sukses!");
      setTimeout(() => {
        navigate('/games')
      }, [1000])
    } catch (error) {
      toast.error("Krijimi i lojës dështoi!");
      console.error("Failed to create game:", error);
    }

    setSubmitting(false);
  };

  const buttons = [
    {
      label: 'Cancel',
      color: 'bg-white',
      border: 'border border-[#D0D5DD]',
      linkTo: '/games/add',
      onClick: (ref) => ref.current?.submitForm(),
      shadow: true
    },
    { label: 'Save', color: 'bg-primary text-white', border: 'border border-b-2 border-primary', shadow: 'shadow-md', icon: <LuCheck />, onClick: handleFormSubmit, linkTo: null }
  ];

  const details = {
    title: 'Krijo lojë lotarie'
  }

  return (
    <>
      <CreateGame details={details} handleSubmit={handleFormSubmit} />
    </>
  );
}
